import {
  affiliateID,
  siteOptions,
  buyerList
} from '../../../../common/commonRequests';

export const stateSuppressionState = ({ detailsView, buyer }) => ({
  site: {
    name: 'site',
    type: 'select',
    label: 'Vertical',
    validate: () => {},
    options: () => siteOptions(),
    value: 0,
    defaultVal: 0,
    error: false,
    message: '',
    hidden: detailsView
  },
  affiliateID: {
    name: 'affiliateID',
    type: 'autocomplete',
    label: 'Affiliate ID',
    validate: () => {},
    options: () => affiliateID(),
    value: 'all',
    defaultVal: '',
    error: false,
    message: ''
  },
  buyer: {
    name: 'buyer',
    type: 'select',
    label: 'Buyer',
    validate: () => {},
    options: (dependency) => buyerList(dependency),
    value: detailsView && buyer ? buyer : '-1',
    defaultVal: '-1',
    error: false,
    message: '',
    dependencyName: 'site',
    hidden: detailsView
  },
  states_map: {
    name: 'states_map',
    type: 'pickStatesMap',
    label: 'Select States',
    value: '',
    defaultVal: 'none',
    error: false,
    message: 'Please select at least 1 state',
    hidden: detailsView ? !detailsView : true
  }
});
